import {
  useEffect,
  useRef,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  Box,
  Image,
  Stack,
  Textarea
} from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { COLORS } from 'utils/styles'
import { ImagesPng } from 'assets/images'
import {
  getNotificationMessage,
  postEventComment,
  putEventComment,
  markersSelectors,
  usersSelectors
} from 'store'
import {
  PENDING,
  REJECTED,
  SUCCEEDED
} from 'utils/constants'
import { LoadingSpinier } from 'common/Loading'

const MotionStack = motion(Stack)

export const CreateComment = ({
  editCommentData,
  setEditCommentData
}) => {
  const {
    activeProfile,
    eventCommentTree,
    getEventCommentsStatus,
    postEventCommentStatus,
    putEventCommentStatus
  } = useSelector(usersSelectors)
  const { eventData } = useSelector(markersSelectors)

  const dispatch = useDispatch()
  const formBodyRef = useRef(null)
  const parentStackRef = useRef(null)
  const [body, setBody] = useState('')
  const [show, setShow] = useState(false)

  const closeForm = () => {
    setBody('')
    setEditCommentData({})
  }

  const submitForm = () => {
    if (body.trim() === '') {
      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'Body field is required',
          isEditProfile: true
        })
      )
    } else if (Object.keys(editCommentData).length === 0) {
      dispatch(postEventComment({
        event_id: eventData?.id,
        body,
        ...(eventCommentTree.at(-1)?.event_id && { parent_comment_id: eventCommentTree.at(-1)?.id })
      }))
    } else {
      dispatch(putEventComment({
        comment_id: editCommentData.id,
        body
      }))
    }
  }

  const focusBodyRef = () => {
    if (formBodyRef.current) {
      formBodyRef.current.blur()
      formBodyRef.current.focus()
    }
  }

  useEffect(() => {
    if (formBodyRef.current) {
      formBodyRef.current.style.height = '5px'
      formBodyRef.current.style.height = `
        ${formBodyRef.current.scrollHeight}px
      `
    }
  }, [body])

  useEffect(() => {
    if (Object.keys(editCommentData).length !== 0) {
      setBody(editCommentData.body)
      focusBodyRef()
    }
  }, [editCommentData])

  useEffect(() => {
    if (postEventCommentStatus === SUCCEEDED) {
      closeForm()
    }
  }, [postEventCommentStatus])

  useEffect(() => {
    if (putEventCommentStatus === SUCCEEDED) {
      closeForm()
    }
  }, [putEventCommentStatus])

  useEffect(() => {
    closeForm()
  }, [eventCommentTree])

  useEffect(() => {
    focusBodyRef()

    setTimeout(() => setShow(true), 850)
  }, [])

  return show
    ? (
      <MotionStack
        initial={{ maxHeight: 0 }}
        animate={{ maxHeight: '100px' }}
        transition={{
          type: 'tween',
          duration: 0.8
        }}
        ref={parentStackRef}
        style={{ willChange: 'max-height' }}
        overflow="hidden"
        background={COLORS.grayGradientTopToBot}
        width="100%"
        border="solid 1px black"
        borderRadius="3px"
        flexShrink={0}
      >
        <Stack
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
          flexDirection="row"
          padding={body.length ? '8px 8px 0 8px' : '8px 8px 12px 8px'}
          transition="0.5s ease"
        >
          <Image
            boxSize="45px"
            objectFit="cover"
            src={activeProfile?.profile_picture || ImagesPng.DefaultImage}
            alt="User Image"
            borderRadius="full"
            display="inline-flex"
          />

          <Textarea
            ref={formBodyRef}
            background={COLORS.lighterGray}
            placeholder="Add your comment here"
            width="100%"
            height="43px"
            minHeight="2.8em"
            overflow="hidden"
            resize="none"
            name="blog-body"
            value={body}
            onChange={(e) => setBody(e.target.value)}
          />
        </Stack>
        <Stack
          direction="row"
          justifyContent="flex-end"
          margin="-10.5px 0 0 0"
          fontSize="13px"
          overflow="hidden"
          display="flex"
          padding={body.length ? '8px' : '0'}
          height={body.length ? '47px' : '0'}
          transition="0.5s ease"
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            borderRadius="full"
            bg={COLORS.gold}
            p="6px 10px"
            data-name="blog-cancel"
            cursor="pointer"
            onClick={() => closeForm()}
            _hover={{ background: COLORS.gold_hover }}
            transition="background 0.3s"
            pointerEvents={putEventCommentStatus !== PENDING && postEventCommentStatus !== PENDING ? 'auto' : 'none'}
            overflow="hidden"
          >
            Cancel
          </Box>
          <Box
            display={
              putEventCommentStatus === PENDING
              || postEventCommentStatus === PENDING
                ? 'block'
                : 'flex'
            }
            alignItems="center"
            justifyContent="center"
            borderRadius="full"
            bg={COLORS.gold}
            p="6px 10px"
            data-name="blog-post"
            cursor="pointer"
            _hover={{ background: COLORS.gold_hover }}
            transition="0.3s"
            pointerEvents={
              putEventCommentStatus !== PENDING
              && postEventCommentStatus !== PENDING
              && getEventCommentsStatus !== PENDING
                ? 'auto'
                : 'none'
            }
            onClick={() => submitForm()}
            overflow="hidden"
          >
            {
              putEventCommentStatus === PENDING
              || postEventCommentStatus === PENDING
                ? (
                  <Stack>
                    <LoadingSpinier
                      width="10px"
                      height="10px"
                      marginTop="23px"
                    />
                  </Stack>
                ) : 'Post'
            }
          </Box>
        </Stack>
      </MotionStack>
    ) : ''
}
